import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { CollapseBlock } from '../../../../../common/index.jsx';
import { Spinner } from '../../../../../common/index.jsx';
import FijInterestsTable from './FijInterestsTable.jsx';
import { useGetInternsQuery } from '../../../../../../redux/services/fij_internal_jobs.jsx';
import useUserHasRole from '../../../../../../hooks/useUserHasRoles.jsx';
import {
  ROLE_FRI_INTERNAL_JOBS_ADMIN,
} from '../../../../../../utils/constants/roles.js';

const FijInterestedPage = () => {
  const { t } = useTranslation();

  const { id } = useParams();
  const {
    data: internsPayload,
    isLoading: isInterestsLoading,
    refetch: refetchInterests,
  } = useGetInternsQuery(id, { skip: !id });

  const internalJob = internsPayload?.internalJob;
  const interests = internsPayload?.interests;

  const isFijAdmin = useUserHasRole(ROLE_FRI_INTERNAL_JOBS_ADMIN);

  const pageTitle = t('Zoznam záujemcov o FRI prax');
  useEffect(() => {
    document.title = pageTitle + ' - FRI.prax';
  }, []); // Runs on mount

  return isInterestsLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={pageTitle + ': ' + (internalJob?.name || '-')}
        backUrl={-1}
        backUrlTooltip={t('Zoznam FRI praxí')}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock collapsible title={t('Zoznam záujemcov')}>
          <FijInterestsTable
            interests={interests ?? []}
            internalJob={internalJob ?? null}
            isFijAdmin={isFijAdmin}
            refetchData={() => {
              refetchInterests();
            }}
          />
        </CollapseBlock>
      </div>
    </>
  );
};

export default FijInterestedPage;
